export default "__VITE_ASSET__Ca1648lT__"